import React from 'react'
import { compose, pure } from 'recompose'
import { translate } from 'react-i18next'
import styles from './customCheckmarkComponent.scss'
import PropTypes from 'prop-types'

export function CustomCheckmark (props: Props) {
  const { t } = props
  const label = props.input.label || props.label
  const meta = props.input.meta || props.meta
  return (
    <div className={[props.wrapperStyle, styles.customCheck].join(' ')}>
      <input {...props.input} type={'checkbox'} id={props.input.name} />
      <label htmlFor={props.input.name}>
        {label}
      </label>
      <div className={styles.errorList}>
        {meta &&
          meta.touched &&
          ((meta.error &&
            <span className={styles.error}>
              {t(`errors:${meta.error}`)}
            </span>) ||
            (meta.warning &&
              <span>
                {t(`errors:${meta.warning}`)}
              </span>))}
      </div>
    </div>
  )
}

CustomCheckmark.propTypes = {
  wrapperStyle: PropTypes.string,
  label: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  t: PropTypes.func.isRequired
}

export default compose(translate(), pure)(CustomCheckmark)



// WEBPACK FOOTER //
// ./src/forms/components/customCheckmark/customCheckmarkComponent.js